<template>
  <div class="award-page">
    <header-pane
      class="award-page__header"
      colorType="light"
      :pageTitle="$tc('LinkPage.pageTitle')"
      navigationCurrent="link"
      :hasHeaderNav="hasHeaderNav"
    />
    <sub-header-section
      :pageTitle="$tc('LinkPage.AwardPage.pageTitle')"
      :execTransitionEventParent="true"
      @onClick="backToPreviousPage"
    />

    <award-pane class="award-page__content" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import HeaderPane from '@/components/common/Header/HeaderPane.vue'
import AwardPane from '@/components/LinkPage/AwardPane.vue'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'

/**
 * SFgo Award ページ
 */
export default defineComponent({
  name: 'AwardPage',
  components: {
    SubHeaderSection,
    HeaderPane,
    AwardPane,
  },
  props: {
    /**
     * ヘッダーナビ表示指定
     */
    hasHeaderNav: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    /**
     * 前のページに遷移する
     */
    backToPreviousPage() {
      return this.$router.back()
    },
  },
})
</script>

<style lang="scss" scoped>
.award-page {
  background: $gray1;
  min-height: var(--screen-height);
  padding-bottom: var(--safe-area-inset-bottom);
}
</style>

<style lang="scss">
.award-page {
  .award-pane {
    height: calc(100vh - #{$headerPaneHeight} - #{$subHeaderPaneHeight});
  }
}
</style>
